function isAllZeros(str: any) {
  return /^0+$/.test(str)
}

export const safeDivide = (a: number, b: number) => (isNaN(a / b) ? 0 : a / b)

export const formatNumber = (number: any, max: any) => {
  if (Number(number) >= 1) {
    let [integerPart, decimalPart] = number.toString().split('.')
    if (integerPart !== '0') {
      integerPart = parseInt(integerPart).toLocaleString('en-US')
    }
    decimalPart = decimalPart ? decimalPart.substring(0, max) : ''
    if (isAllZeros(decimalPart)) {
      decimalPart = ''
    }
    return decimalPart ? `${integerPart}.${decimalPart} ` : integerPart
  } else if (Number(number) < 1) {
    const factor = Math.pow(10, max)
    return Math.floor(number * factor) / factor
  } else {
    return 0
  }
}
